import {
  attempt,
  delay,
  isNil,
  isNull
} from 'lodash-es';

import {UserApi} from 'static/three-oh/src/modules/apis';

export const isEmptyValue = (str) => {
  const emptyStringRegex = /^ *$/;
  return isNil(str) || emptyStringRegex.test(str);
};

export const getEmailDomain = (email) => {
  if (email) {
    const atSymbIndex = email.lastIndexOf('@');
    return email.slice(atSymbIndex + 1);
  }
  return '';
};

export const invalidEmailCheck = (email) => {
  const invalidEmailRegex = /^(?:[\w!#$%&'*+\-/=?^`{|}~]+\.)*[\w!#$%&'*+\-/=?^`{|}~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
  return !invalidEmailRegex.test(email);
};

export const isEmailInUse = async(email) => {
  return await UserApi.getByQuery({
    email: email,
  }).then((result) => {
    if (result.length > 0) {
      return true;
    } else {
      return false;
    }
  }).catch(() => {
    // if user not found, a statusCode === 404 is returned
    return false;
  });
};

// can only contain alphanumeric values =< 75 chars
export const isValidUsername = (username) => {
  const usernameRegex = /^[a-zA-Z0-9.]{0,75}$/;
  return usernameRegex.test(username);
};

export const isValidUSZipCode = (value) => {
  const zipCodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
  return zipCodeRegex.test(value);
};

export const isValidCanadianZipCode = (value) => {
  const zipCodeRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/i;
  return zipCodeRegex.test(value);
};

export const invalidZipCode = (zipCode, country) => {
  if (country.abbreviation === '' || isNull(country.abbreviation)) return false;
  if (country.abbreviation === 'US') {
    return !isValidUSZipCode(zipCode);
  } else if (country.abbreviation === 'CA') {
    return !isValidCanadianZipCode(zipCode);
  } else {
    // based on Address model max_length for zip_code
    return zipCode.length > 20;
  }
};

export const isUsernameInUse = async(username) => {
  return await UserApi.getByQuery({
    username: username,
  }).then((result) => {
    if (result.length > 0) {
      return true;
    } else {
      return false;
    }
  }).catch(() => {
    // if user not found, a statusCode === 404 is returned
    return false;
  });
};

export const isUnitedStates = (country) => {
  return country?.abbreviation === 'US';
};

/**
 * Returns true if the country is not the United States(US),
 * or if an associated value is empty. The value will typically
 * be the country name or abbreviation
 * */
export const isUSorEmptyValue = (country, countryValue) => {
  return isUnitedStates(country) || countryValue === '';
};

export const identifyMarketoLead = (user) => {
  // Find out who is logged in and identify them to Marketo.
  // Associates the current _mkto_trk activity tracking cookie with a Marketo lead record.
  const munchkinHash = user.marketo_munchkin_hash;
  if (!munchkinHash) {
    // No Marketo lead on record for this user, abort!
    return Promise.resolve();
  }

  const data = {
    Email: user.email,
    unique_id: user.unique_id,
    FirstName: user.first_name,
    LastName: user.last_name,
  };

  // Marketo doesn't provide an async callback for their identifier function, so instead we
  // chill for ~500ms to give it a chance to run before resolving.
  return new Promise((resolve) => {
    attempt(() => window.Munchkin.munchkinFunction('associateLead', data, munchkinHash));
    delay(resolve, 500);
  });
};
